import React from 'react'
// import Head from '../../Components/Faq/Head'
import Accordians from '../../Components/Faq/Accordians'

const Faq = () => {
  return (
   <>
   <Accordians />
   </>
  )
}

export default Faq